import { call, put, takeLatest, fork, all, select } from 'redux-saga/effects';
import { getRequest, postRequest, getErrorRequest } from '../../util/apiFetch'; 
import {
  showGlobalLoading,
  hideGlobalLoading,
  COT20_FETCH_SERVICIOS_REQUEST,
  fetchGetServiciosSuccess,
  fetchGetServiciosFailure, 
  fetchSetErrorDialogGlobal,
  COT20_FETCH_EJECUTIVOS_REQUEST,
  fetchGetEjecutivosSuccess,
  fetchGetEjecutivosFailure,
  COT20_FETCH_COMUNAS_DESTINO_REQUEST,
  fetchGetComunasDestinoSuccess,
  fetchGetComunasDestinoFailure,  
  COT20_FETCH_PUERTOS_REQUEST,
  fetchGetPuertosSuccess,
  fetchGetPuertosFailure,
  COT20_FETCH_TIPOS_CARGAS_REQUEST,
  fetchGetTiposCargasSuccess,
  fetchGetTiposCargasFailure,
  COT20_FETCH_TIPOS_CONTENEDORES_REQUEST,
  fetchGetTiposContenedoresSuccess,
  fetchGetTiposContenedoresFailure,
  COT20_FETCH_TIPOS_INCOTERMS_REQUEST,
  fetchGetTiposIncotermsSuccess,
  fetchGetTiposIncotermsFailure,
  COT20_FETCH_GET_CLIENTE_BY_ID,
  fetchGetClienteByIdSuccess,
  fetchGetClienteByIdFailure,
  fetchSetCotizacion,
  COT20_FETCH_COTIZACION_20_SAVE,
  fetchCotizacion20SaveSuccess,
  fetchCotizacion20SaveFailure,
  COT20_FETCH_COTIZACION_20_ACCEPT,
  fetchCotizacion20AcceptSuccess,
  fetchCotizacion20AcceptFailure,
  COT20_FETCH_SERVICIOS_VALORES_REQUEST,
  fetchGetServiciosValoresSuccess,
  fetchGetServiciosValoresFailure,
  COT20_FETCH_SEND_EMAIL_COTIZACION,
  fetchSendEmailCotizacionSuccess,
  fetchSendEmailCotizacionFailure,
} from './actions';

// --- Worker Saga: Fetching Comunas Destino ---
function* fetchGetComunasDestinoSaga() {
  yield put(showGlobalLoading());
  const requestURL = 'cotizador20/getComunasDestino';
  try {
    const response = yield call(getRequest, requestURL);
    const { error, message } = yield call(getErrorRequest, response);
    if (error) {
      yield put(fetchSetErrorDialogGlobal({ open: true, message: error.message || 'Ocurrió un error inesperado al obtener las comunas destino.', title: 'Error al obtener las comunas destino.' }));
    } else {
      const respTxt = yield response.text();
      const data = JSON.parse(respTxt);
      yield put(fetchGetComunasDestinoSuccess(data.comunasDestino));
    }
  } catch (error) {
    yield put(fetchSetErrorDialogGlobal({ open: true, message: error || 'Ocurrió un error inesperado al obtener las comunas destino.', title: 'Error al obtener las comunas destino.' }));
  } finally {
    yield put(hideGlobalLoading());
  }
}
// --- End Worker Saga: Fetching Comunas Destino ---

// --- Watcher Saga: Fetching Comunas Destino ---
function* watchFetchGetComunasDestino() {
  yield takeLatest(COT20_FETCH_COMUNAS_DESTINO_REQUEST, fetchGetComunasDestinoSaga);
}
// --- End Watcher Saga: Fetching Comunas Destino --- 

// --- Worker Saga: Fetching Send Email Cotizacion ---
function* fetchSendEmailCotizacionSaga(action) {
  yield put(showGlobalLoading());
  const cotizacion = action.payload;
  const requestURL = 'cotizador20/sendEmailCotizacion';
  try { 
    const response = yield call(postRequest, requestURL, cotizacion, true);
    const { error, message } = yield call(getErrorRequest, response);
    if (error) {
      yield put(fetchSendEmailCotizacionFailure(error));
    } else {
      yield put(fetchSendEmailCotizacionSuccess(response.data));
    }
  } catch (error) { 
    yield put(fetchSendEmailCotizacionFailure(error));
  } finally {
    yield put(hideGlobalLoading());
  }
}
// --- End Worker Saga: Fetching Send Email Cotizacion ---  

// --- Watcher Saga: Fetching Send Email Cotizacion ---
function* watchFetchSendEmailCotizacion() {
  yield takeLatest(COT20_FETCH_SEND_EMAIL_COTIZACION, fetchSendEmailCotizacionSaga);
}
// --- End Watcher Saga: Fetching Send Email Cotizacion ---

// --- Worker Saga: Fetching Servicios Valores ---
function* fetchGetServiciosValoresSaga() {
  yield put(showGlobalLoading());
  const requestURL = 'cotizador20/getServiciosValores';
  try {
    const response = yield call(getRequest, requestURL);
    const { error, message } = yield call(getErrorRequest, response);
    if (error) {
      yield put(fetchSetErrorDialogGlobal({ open: true, message: error || 'Ocurrió un error inesperado al obtener los servicios valores.', title: 'Error al obtener los servicios valores.' }));
    } else {
      const respTxt = yield response.text();
      const data = JSON.parse(respTxt);
      yield put(fetchGetServiciosValoresSuccess(data.serviciosValores));
    }
  } catch (error) {
    yield put(fetchSetErrorDialogGlobal({ open: true, message: error || 'Ocurrió un error inesperado al obtener los servicios valores.', title: 'Error al obtener los servicios valores.' }));
  } finally {
    yield put(hideGlobalLoading());
  }
}
// --- End Worker Saga: Fetching Servicios Valores ---

// --- Watcher Saga: Fetching Servicios Valores ---
function* watchFetchGetServiciosValores() {
  yield takeLatest(COT20_FETCH_SERVICIOS_VALORES_REQUEST, fetchGetServiciosValoresSaga);
}
// --- End Watcher Saga: Fetching Servicios Valores ---


// --- Worker Saga: Fetching Cotizacion 20 Accept ---
function* fetchCotizacion20AcceptSaga(action) {
  yield put(showGlobalLoading());
  const cotizacionId = action.payload;
  const requestURL = `cotizador20/accept`;    
  try {
    const response = yield call(postRequest, requestURL, {cotizacionId} );
    const { error, message } = yield call(getErrorRequest, response);
    if (error) {
      const respTxt = yield response.text();
      const data = JSON.parse(respTxt);
      yield put(fetchSetErrorDialogGlobal({ open: true, message: data.message || 'Ocurrió un error inesperado al aceptar la cotización.', title: 'Error al aceptar la cotización.' }));
    } else {

      const respTxt = yield response.text();
      const data = JSON.parse(respTxt); // Assuming backend returns { success: true, id: ... }

      if (data && data.success && data.id) {
        yield put(fetchCotizacion20AcceptSuccess(data.cotizacion));

      } else {
        yield put(fetchSetErrorDialogGlobal({ open: true, message: data.message || 'Ocurrió un error inesperado al guardar la cotización.', title: 'Error al guardar la cotización.' }));
      }
    }
  } catch (error) {
    yield put(fetchSetErrorDialogGlobal({ open: true, message: error || 'Ocurrió un error inesperado al aceptar la cotización.', title: 'Error al aceptar la cotización.' })); 
  } finally {
    yield put(hideGlobalLoading());
  }
}
// --- Worker Saga: Fetching Cotizacion 20 Save ---
function* fetchCotizacion20SaveSaga(action) {
  yield put(showGlobalLoading());
  const cotizacion = action.payload;
  const requestURL = 'cotizador20/save';    
  try {
    const response = yield call(postRequest, requestURL, cotizacion);
    const { error, message } = yield call(getErrorRequest, response);
    if (error) {
      const respTxt = yield response.text();
      const data = JSON.parse(respTxt);
      yield put(fetchSetErrorDialogGlobal({ open: true, message: data.message || 'Ocurrió un error inesperado al guardar la cotización.', title: 'Error al guardar la cotización.' }));
    } else {

      const respTxt = yield response.text();
      const data = JSON.parse(respTxt); // Assuming backend returns { success: true, id: ... }

      if (data && data.success && data.id) {
        yield put(fetchCotizacion20SaveSuccess(data.cotizacion));

      } else {
        yield put(fetchSetErrorDialogGlobal({ open: true, message: data.message || 'Ocurrió un error inesperado al guardar la cotización.', title: 'Error al guardar la cotización.' }));
      }
    }
  } catch (error) {
    yield put(fetchSetErrorDialogGlobal({ open: true, message: error || 'Ocurrió un error inesperado al guardar la cotización.', title: 'Error al guardar la cotización.' }));
  } finally {
    yield put(hideGlobalLoading());
  }
}
// --- Action Creators for Fetching Tipos Incoterms ---
function* fetchGetTiposIncotermsSaga() {
  yield put(showGlobalLoading());
  const requestURL = 'cotizador20/getTiposIncoterms';
  try { 
    const response = yield call(getRequest, requestURL);
    const { error, message } = yield call(getErrorRequest, response);

    if (error) {
      yield put(fetchSetErrorDialogGlobal({ open: true, message: error.message || 'Ocurrió un error inesperado al obtener los tipos de incoterms.', title: 'Error al obtener los tipos de incoterms.' }));
    } else {
      const respTxt = yield response.text();
      const data = JSON.parse(respTxt);
      yield put(fetchGetTiposIncotermsSuccess(data.tiposIncoterms));
    }
  } catch (error) {
    yield put(fetchSetErrorDialogGlobal({ open: true, message: error || 'Ocurrió un error inesperado al obtener los tipos de incoterms.', title: 'Error al obtener los tipos de incoterms.' }));
  } finally {
    yield put(hideGlobalLoading());
  }
}
// --- End Worker Saga: Fetch Tipos Incoterms ---
  
// --- Watcher Saga: Fetch Tipos Incoterms ---
function* watchFetchGetTiposIncoterms() {
  yield takeLatest(COT20_FETCH_TIPOS_INCOTERMS_REQUEST, fetchGetTiposIncotermsSaga);
}
// --- End Watcher Saga: Fetch Tipos Incoterms ---

// --- Action Creators for Fetching Tipos Contenedores ---
function* fetchGetTiposContenedoresSaga() {
  yield put(showGlobalLoading());
  const requestURL = 'cotizador20/getTiposContenedores';
  try {
    const response = yield call(getRequest, requestURL);
    const { error, message } = yield call(getErrorRequest, response);

    if (error) {
      yield put(fetchSetErrorDialogGlobal({ open: true, message: error.message || 'Ocurrió un error inesperado al obtener los tipos de contenedores.', title: 'Error al obtener los tipos de contenedores.' }));
    } else {  
      const respTxt = yield response.text();
      const data = JSON.parse(respTxt);
      yield put(fetchGetTiposContenedoresSuccess(data.tiposContenedores));
    }
  } catch (error) {
    yield put(fetchSetErrorDialogGlobal({ open: true, message: error || 'Ocurrió un error inesperado al obtener los tipos de contenedores.', title: 'Error al obtener los tipos de contenedores.' }));
  } finally { 
    yield put(hideGlobalLoading());
  }
}
// --- End Worker Saga: Fetch Tipos Contenedores ---

// --- Watcher Saga: Fetch Tipos Contenedores ---
function* watchFetchGetTiposContenedores() {
  yield takeLatest(COT20_FETCH_TIPOS_CONTENEDORES_REQUEST, fetchGetTiposContenedoresSaga);
}
// --- End Watcher Saga: Fetch Tipos Contenedores ---

// --- Action Creators for Fetching Tipos Cargas ---
function* fetchGetTiposCargasSaga() {
  yield put(showGlobalLoading());
  const requestURL = 'cotizador20/getTiposCargas';
  try { 
    const response = yield call(getRequest, requestURL);
    const { error, message } = yield call(getErrorRequest, response);

    if (error) {
      yield put(fetchSetErrorDialogGlobal({ open: true, message: error.message || 'Ocurrió un error inesperado al obtener los tipos de cargas.', title: 'Error al obtener los tipos de cargas.' }));
    } else {  
      const respTxt = yield response.text();
      const data = JSON.parse(respTxt);
      yield put(fetchGetTiposCargasSuccess(data.tiposCargas));
    }
  } catch (error) {
    yield put(fetchSetErrorDialogGlobal({ open: true, message: error || 'Ocurrió un error inesperado al obtener los tipos de cargas.', title: 'Error al obtener los tipos de cargas.' }));
  } finally { 
    yield put(hideGlobalLoading());
  }
}
// --- End Worker Saga: Fetch Tipos Cargas ---

// --- Watcher Saga: Fetch Tipos Cargas ---
function* watchFetchGetTiposCargas() {
  yield takeLatest(COT20_FETCH_TIPOS_CARGAS_REQUEST, fetchGetTiposCargasSaga);
}
// --- End Watcher Saga: Fetch Tipos Cargas ---




// --- Action Creators for Fetching Puertos ---
function* fetchGetPuertosSaga() {
  yield put(showGlobalLoading());
  const requestURL = 'cotizador20/getPuertos';
  try {
    const response = yield call(getRequest, requestURL);
    const { error, message } = yield call(getErrorRequest, response);

    if (error) {
      yield put(fetchSetErrorDialogGlobal({ open: true, message: error.message || 'Ocurrió un error inesperado al obtener los puertos.', title: 'Error al obtener los puertos.' }));
    } else {
      const respTxt = yield response.text();
      const data = JSON.parse(respTxt);
      yield put(fetchGetPuertosSuccess(data.puertos));
    }
  } catch (error) {
    yield put(fetchSetErrorDialogGlobal({ open: true, message: error || 'Ocurrió un error inesperado al obtener los puertos.', title: 'Error al obtener los puertos.' }));
  } finally {
    yield put(hideGlobalLoading()); 
  }
}
// --- End Worker Saga: Fetch Puertos ---

// --- Watcher Saga: Fetch Puertos ---
function* watchFetchGetPuertos() {
  yield takeLatest(COT20_FETCH_PUERTOS_REQUEST, fetchGetPuertosSaga);
}
// --- End Watcher Saga: Fetch Puertos ---

function* fetchGetEjecutivosSaga() {
  yield put(showGlobalLoading());
  const requestURL = 'cotizador20/getEjecutivos';
  try {
    const response = yield call(getRequest, requestURL);
    const { error, message } = yield call(getErrorRequest, response);

    if (error) {
      yield put(fetchSetErrorDialogGlobal({ open: true, message: error.message || 'Ocurrió un error inesperado al obtener los ejecutivos.', title: 'Error al obtener los ejecutivos.' }));
    } else {
      const respTxt = yield response.text();
      const data = JSON.parse(respTxt);
      yield put(fetchGetEjecutivosSuccess(data.ejecutivos));
    }
  } catch (error) {
    yield put(fetchSetErrorDialogGlobal({ open: true, message: error || 'Ocurrió un error inesperado al obtener los ejecutivos.', title: 'Error al obtener los ejecutivos.' }));
  } finally {
    yield put(hideGlobalLoading());
  }
} 

// --- Worker Saga: Fetch Servicios ---
function* fetchGetServiciosSaga() {
  yield put(showGlobalLoading());
  const requestURL = 'cotizador20/getServicios';
  try {
    const response = yield call(getRequest, requestURL);
    const { error, message } = yield call(getErrorRequest, response);

    if (error) {
      yield put(fetchSetErrorDialogGlobal({ open: true, message: message || 'Ocurrió un error inesperado al obtener los servicios.', title: 'Error al obtener los servicios.' }));  

    } else {
      const respTxt = yield response.text();
      const data = JSON.parse(respTxt);
      yield put(fetchGetServiciosSuccess(data.servicios));
    }
  } catch (error) {
    yield put(fetchSetErrorDialogGlobal({ open: true, message: error || 'Ocurrió un error inesperado al obtener los servicios.', title: 'Error al obtener los servicios.' }));  
  } finally {
    yield put(hideGlobalLoading());
  }
}
// --- End Worker Saga: Fetch Servicios ---

// --- Worker Saga: Fetch Cliente By Id ---
function* fetchGetClienteByIdSaga(action) {
  yield put(showGlobalLoading());
  const id = action.payload;
  const requestURL = `cotizador20/getClienteById/${id}`;
  try {
    const response = yield call(getRequest, requestURL); 
    const { error, message } = yield call(getErrorRequest, response);

    if (error) {
      // esto retorno desde el backend res.status(404).json({ success: false, message: "Cliente no encontrado." }); quiero leer el message  
      const respTxt = yield response.text();
      const data = JSON.parse(respTxt);
      yield put(fetchSetErrorDialogGlobal({ open: true, message: data.message || 'Ocurrió un error inesperado al obtener el cliente.', title: 'Error al obtener el cliente.' }));
    } else {
      const respTxt = yield response.text();
      const data = JSON.parse(respTxt);
      // Obtenemos el estado actual de la cotización, verificando que state.cotizador20 exista
      yield put(fetchGetClienteByIdSuccess(data.cliente));
    }
  } catch (error) {
    yield put(fetchSetErrorDialogGlobal({ open: true, message: error || 'Ocurrió un error inesperado al obtener el cliente.', title: 'Error al obtener el cliente.' }));
  } finally {
    yield put(hideGlobalLoading());
  }
}

// --- Watcher Saga: Fetch Servicios ---
function* watchFetchGetServicios() {
  yield takeLatest(COT20_FETCH_SERVICIOS_REQUEST, fetchGetServiciosSaga);
}
// --- End Watcher Saga: Fetch Servicios ---  

// --- Watcher Saga: Fetch Ejecutivos ---
function* watchFetchGetEjecutivos() {
  yield takeLatest(COT20_FETCH_EJECUTIVOS_REQUEST, fetchGetEjecutivosSaga);
}
// --- End Watcher Saga: Fetch Ejecutivos ---

// --- Watcher Saga: Fetch Cliente By Id ---
function* watchFetchGetClienteById() {
  yield takeLatest(COT20_FETCH_GET_CLIENTE_BY_ID, fetchGetClienteByIdSaga);
}
// --- End Watcher Saga: Fetch Cliente By Id ---

// --- Watcher Saga: Fetch Cotizacion 20 Save ---
function* watchFetchCotizacion20Save() {
  yield takeLatest(COT20_FETCH_COTIZACION_20_SAVE, fetchCotizacion20SaveSaga);
}
// --- End Watcher Saga: Fetch Cotizacion 20 Save ---

// --- Watcher Saga: Fetch Cotizacion 20 Accept ---
function* watchFetchCotizacion20Accept() {
  yield takeLatest(COT20_FETCH_COTIZACION_20_ACCEPT, fetchCotizacion20AcceptSaga);
}
// --- End Watcher Saga: Fetch Cotizacion 20 Accept ---

export default function* cotizador20Saga() {
  yield all([
    fork(watchFetchGetComunasDestino),
    fork(watchFetchGetTiposCargas),
    fork(watchFetchGetTiposContenedores),
    fork(watchFetchGetPuertos),
    fork(watchFetchGetEjecutivos),
    fork(watchFetchGetServicios),
    fork(watchFetchGetTiposIncoterms),
    fork(watchFetchGetClienteById),
    fork(watchFetchCotizacion20Save),
    fork(watchFetchCotizacion20Accept),
    fork(watchFetchGetServiciosValores),
    fork(watchFetchSendEmailCotizacion),
  ]);
}; 